<template>
  <input
      :type="inputType"
      :value="formattedValue"
      :min="formattedMin"
      @input="onInput($event.target.value)"
      class="form-control"
  />
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class DateTimeInput extends Vue {
  // v-model
  @Prop({ required: true }) readonly value!: Date | string;

  // afficher ou non l'heure/minute
  @Prop({ default: false }) readonly showTime!: boolean;

  // date minimum sélectionnable
  @Prop({ default: null }) readonly min!: Date | string | null;

  // type d'input HTML (date ou datetime-local)
  get inputType(): string {
    return this.showTime ? 'datetime-local' : 'date';
  }

  get formattedMin(): string {
    if (!this.min) return '';
    const date = this.min instanceof Date ? this.min : new Date(this.min);
    if (isNaN(date.getTime())) return '';
    return this.showTime ? date.toISOString().slice(0, 16) : date.toISOString().slice(0, 10);
  }

  // conversion interne pour afficher correctement dans l'input
  get formattedValue(): string {
    if (!this.value) return '';
    const date = this.value instanceof Date ? this.value : new Date(this.value);

    if (isNaN(date.getTime())) return '';

    if (this.showTime) {
      return date.toISOString().slice(0, 16); // yyyy-MM-ddTHH:mm
    } else {
      return date.toISOString().slice(0, 10); // yyyy-MM-dd
    }
  }

  onInput(val: string) {
    if (!val) {
      this.$emit('input', '');
      return;
    }

    if (this.value instanceof Date) {
      // retourne un Date
      const date = this.showTime ? new Date(val) : new Date(val + 'T00:00');
      this.$emit('input', date);
    } else {
      // retourne un string
      this.$emit('input', val);
    }
  }

  // watcher pour forcer mise à jour si value change de manière externe
  @Watch('value')
  onValueChange() {
    // Force le recalcul de formattedValue
    this.$forceUpdate();
  }
}
</script>

<style scoped>
.form-control {
  padding: 0.4em 0.6em;
  font-size: 1rem;
}
</style>
